import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { registerAgentCorpo } from '../../../../configration_data/configration';
import ProtectedPaymentRoute from '../../../../auth/Auth';
import { Modal } from 'antd';

export default function RegisterAgentCorpo() {
  ProtectedPaymentRoute();

  const [showCustomModal, setShowCustomModal] = useState(false);
  const navigate = useNavigate();

  const clickNext = () => {
    navigate('/agreement');
  };

  const backbtn = () => {
    navigate('/compliant');
  };

  const handleCustomAgentProceed = () => {
    setShowCustomModal(false);
    navigate('/agreement');
  };

  return (
    <div className="min-h-[75vh] bg-white py-12 lg:py-20 font-sans">
      <div className="container mx-auto px-4 lg:px-8 max-w-6xl">
        <div className="mb-10 text-center max-w-3xl mx-auto">
          <span className="text-[#1a73e8] font-medium tracking-wider uppercase text-xs mb-2 block">
            Corporate Registered Agent Service
          </span>
          <h1 className="text-3xl sm:text-4xl font-normal text-[#202124] tracking-tight mb-3">
            Relax with our corporate registered agent service
          </h1>
          <p className="text-[15px] text-[#5f6368] leading-relaxed">
            Appoint Oktobiz as your official Registered Agent to maintain statutory compliance, protect personal privacy, and process legal correspondence reliably.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10 max-w-6xl mx-auto items-stretch">
          {registerAgentCorpo.map((ele) => (
            <div
              key={ele.title}
              className="p-7 rounded-[12px] border border-[#dadce0] bg-white hover:border-[#1a73e8] hover:shadow-md transition-all flex flex-col"
            >
              <div className="w-12 h-12 rounded-[8px] bg-[#e8f0fe] flex items-center justify-center text-[#1a73e8] mb-5 text-xl">
                <i className="fa-regular fa-circle-check" aria-hidden="true"></i>
              </div>
              <h4 className="text-[18px] font-medium text-[#202124] mb-2.5">
                {ele.title}
              </h4>
              <p className="text-[14.5px] text-[#5f6368] leading-relaxed">
                {ele.pera}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-[#f8f9fa] rounded-[8px] p-4 text-[13px] text-[#5f6368] text-center mb-8 border border-[#dadce0] max-w-6xl mx-auto">
          No charges until your filing documents are submitted to the state. Renews automatically each year. Cancel online anytime after appointing a replacement agent.
        </div>

        <div className="flex flex-col items-center gap-4 pt-6 border-t border-[#f1f3f4] max-w-6xl mx-auto">
          <div className="flex items-center justify-between w-full">
            <button
              type="button"
              onClick={backbtn}
              className="px-6 py-2.5 rounded-[4px] border border-[#dadce0] text-[#1a73e8] font-medium hover:bg-[#f8f9fa] transition-colors flex items-center gap-2 cursor-pointer text-[14px]"
            >
              <i className="fa-solid fa-arrow-left text-xs"></i> Back
            </button>
            <button
              type="button"
              onClick={clickNext}
              className="px-8 py-2.5 rounded-[4px] bg-[#1a73e8] hover:bg-[#1557b0] !text-white font-medium shadow-sm transition-all flex items-center gap-2 cursor-pointer text-[14px]"
            >
              Continue with Oktobiz <i className="fa-solid fa-arrow-right text-xs"></i>
            </button>
          </div>

          <button
            type="button"
            onClick={() => setShowCustomModal(true)}
            className="text-[13.5px] text-[#5f6368] hover:text-[#1a73e8] underline transition-colors mt-2 cursor-pointer bg-transparent border-none"
          >
            Appoint a different registered agent
          </button>
        </div>

        {/* Custom Registered Agent Information Modal */}
        <Modal
          open={showCustomModal}
          onCancel={() => setShowCustomModal(false)}
          footer={null}
          centered
          width={480}
        >
          <div className="p-2 text-center">
            <div className="w-12 h-12 rounded-full bg-[#e8f0fe] text-[#1a73e8] flex items-center justify-center mx-auto mb-3.5 text-xl">
              <i className="fa-solid fa-user-tie"></i>
            </div>
            <h3 className="text-lg font-medium text-[#202124] mb-2">
              Appoint a Different Registered Agent?
            </h3>
            <p className="text-[13.5px] text-[#5f6368] leading-relaxed mb-6">
              State regulations require every corporation to maintain an official registered agent with a physical street address (no P.O. boxes) in the state of formation to receive legal service of process during business hours.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-3">
              <button
                type="button"
                onClick={handleCustomAgentProceed}
                className="w-full sm:flex-1 py-2.5 rounded-[4px] border border-[#dadce0] text-[#5f6368] hover:text-[#202124] hover:bg-[#f8f9fa] font-medium transition-colors text-[13.5px] cursor-pointer"
              >
                Use My Own Agent
              </button>
              <button
                type="button"
                onClick={() => {
                  setShowCustomModal(false);
                  clickNext();
                }}
                className="w-full sm:flex-1 py-2.5 rounded-[4px] bg-[#1a73e8] hover:bg-[#1557b0] !text-white font-medium shadow-sm transition-all text-[13.5px] cursor-pointer"
              >
                Use Oktobiz Agent
              </button>
            </div>
          </div>
        </Modal>

      </div>
    </div>
  );
}
